export const selectFeatureSwitches = state => state.environment.featureSwitches;
export const selectIsFeatureEnabled = featureName => state =>
    selectFeatureSwitches(state)?.[featureName] === true;

export const selectAppInfo = state => ({
    isHybridAppContextForAndroid:
        state.environment.isHybridAppContextForAndroid,
    isHybridAppContextForIos: state.environment.isHybridAppContextForIos,
    isHybridAppContext: state.environment.isHybridAppContext,
    isNativeAppContext: state.environment.isNativeAppContext,
    hybridAppVersion: state.environment.hybridAppVersion
});

export const selectEnvVariables = state => state.environment.variables;
